
import { makeStyles } from '@material-ui/core';


export const useChipStyle = (
  defaultStyle,
  customStyle,
) =>
  makeStyles({
    root: {
      ...defaultStyle,
      ...(customStyle && customStyle),
    },
  });

export const useStyles = makeStyles(theme => ({
  chipItemStyle: {
    marginBottom: 4,
    marginRight: 4,
    cursor: 'pointer',
  },
  chipNumberStyle: {
    cursor: 'pointer',
  },
  tooltipContainerStyle: {
    maxHeight: 200,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
  },
}));
